<template>
  <div class="main">
    <HeaderTitle title="Info Area">
      <IconInfo color="#14444f" size="w-11 h-11" />
    </HeaderTitle>
    <MainContent>
      <div class="pt-5 pb-5">
        <SearchInput @input="search" id="area" addClass="w-52" />

        <div class="pt-5" v-if="!features.loading">
          <div
            class="overflow-x-auto relative shadow-md rounded-lg"
            v-if="features.rows?.length != 0"
          >
            <table class="w-full text-sm text-left text-gray-500">
              <thead>
                <tr class="bg-white border-b">
                  <th scope="row" class="py-3 px-3 text-center">#</th>
                  <th scope="row" class="py-3 px-3 text-center">Kode Petak</th>
                  <th scope="row" class="py-3 px-2 text-center">Pabrik Gula</th>
                  <th scope="row" class="py-3 px-2 text-center">Nama Kebun</th>
                  <th scope="row" class="py-3 px-2 text-center">Kategori</th>
                  <th scope="row" class="py-3 px-2 text-center">Nama Petani</th>
                  <th scope="row" class="py-3 px-2 text-center">Varietas</th>
                  <th scope="row" class="py-3 px-2 text-center">
                    Nama Koperasi
                  </th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <tr
                  class="bg-white border-b"
                  v-for="(item, index) in features.rows"
                  :key="item.properties.feature_id"
                  :class="[
                    {
                      'hover:bg-lightGray':
                        selected != item.properties.feature_id,
                    },
                    { 'bg-gray100': selected == item.properties.feature_id },
                  ]"
                >
                  <td class="py-3 px-2 text-center">
                    {{ (page - 1) * limit + (index + 1) }}
                  </td>
                  <td class="py-2 px-3">{{ item.properties.kode_petak }}</td>
                  <td class="py-2 px-2 text-center">
                    {{ item.properties.pabrikgula }}
                  </td>
                  <td class="py-2 px-2">{{ item.properties.namakebun }}</td>
                  <td
                    class="py-2 px-3"
                    :class="!isSidebarOpen ? 'text-center' : ''"
                  >
                    {{ item.properties.kategori }}
                  </td>
                  <td class="py-2 px-2">{{ item.properties.namapetani }}</td>
                  <td class="py-2 px-3">{{ item.properties.varietas }}</td>
                  <td
                    class="py-2 px-2"
                    :class="
                      !isSidebarOpen ? 'whitespace-nowrap' : 'whitespace-normal'
                    "
                  >
                    {{ item.properties.namakopera }}
                  </td>
                  <td class="py-2 px-3">
                    <div class="flex items-center justify-center">
                      <button
                        class="bg-blue-800 hover:bg-blue-900 rounded-full p-1"
                        @click="onClick(item.properties)"
                      >
                        <IconEye color="white" size="w-3 h-3" />
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <PaginationComponent
              v-model:length="length"
              v-model:size="limit"
              v-model:page="page"
              @onSelectChange="changePage"
            />
          </div>
        </div>

        <LoadingLottie v-if="features.loading"></LoadingLottie>
        <div class="flex justify-center" v-if="features.rows?.length == 0">
          <NoData size="w-full md:w-5/12" />
        </div>
        <AlertErrorComponent
          v-if="features.error"
          :message="features.error.response.data.message"
        />
      </div>
    </MainContent>
  </div>
  <DetailSgnkso />
</template>
<script>
import HeaderTitle from "@/components/HeaderTitle.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconInfo from "@/components/icons/IconInfo.vue";
import MainContent from "@/components/MainContent.vue";
import { useSceneStore, useSidebarStore } from "@/store";
import { onMounted, ref } from "vue";
import { storeToRefs } from "pinia";
import PaginationComponent from "@/components/PaginationComponent.vue";
import LoadingLottie from "@/components/LoadingLottie.vue";
import NoData from "@/components/NoData.vue";
import AlertErrorComponent from "@/components/AlertErrorComponent.vue";
import SearchInput from "@/components/SearchInput.vue";
import DetailSgnkso from "./DetailSgnkso.vue";

export default {
  components: {
    HeaderTitle,
    IconInfo,
    MainContent,
    IconEye,
    PaginationComponent,
    LoadingLottie,
    NoData,
    AlertErrorComponent,
    SearchInput,
    DetailSgnkso,
  },
  setup() {
    const sidebarStore = useSidebarStore();
    const { selected, isSidebarOpen } = storeToRefs(sidebarStore);
    // const sgnksoStore = usesgnksoStore();
    // const { sgnkso } = storeToRefs(sgnksoStore);
    const sceneStore = useSceneStore();
    const { features } = storeToRefs(sceneStore);

    const offset = ref(0);
    const limit = ref(50);
    const length = ref(0);
    const page = ref(1);

    const q = ref("");

    const getAllsgnkso = async () => {
      // await sgnksoStore.getAllsgnkso({
      //   limit: limit.value,
      //   offset: offset.value,
      // });
      // length.value = sgnkso.value.count;

      await sceneStore.getAllSgnksofeatures({
        offset: offset.value,
      });
      length.value = features.value.count;
    };

    onMounted(() => {
      getAllsgnkso();
    });

    const search = async (value) => {
      q.value = value.target.value;
      offset.value = 0;
      page.value = 1;

      let dataParams = { offset: offset.value, q: value.target.value };

      await sceneStore.getAllSgnksofeatures(dataParams);
      length.value = features.value.count;
    };

    const onClick = (value) => {
      selected.value = value.feature_id;
      isSidebarOpen.value = true;
      sidebarStore.$patch((state) => {
        if (!state.open) {
          state.open = !state.open;
        }

        if (state.id != value.feature_id) {
          state.id = value.feature_id;
          state.data = value;
        }
      });
    };

    const changePage = async (value) => {
      sidebarStore.open = false;
      page.value = value;
      offset.value = (page.value - 1) * limit.value;
      let dataparams = { offset: offset.value };
      if (q.value != "") {
        dataparams = { ...dataparams, q: q.value };
      }
      await sceneStore.getAllSgnksofeatures(dataparams);
      length.value = features.value.count;
    };

    return {
      limit,
      page,
      length,
      selected,
      isSidebarOpen,
      // sgnkso,
      onClick,
      changePage,
      search,
      features,
    };
  },
};
</script>
<style></style>
